import { InstallationExtensionsDto, InstallationExtensionsModel } from '../models/installation-extensions.model'
import { ExtensionType } from '../types'

const fromDtoToModelTransformer = (dto: InstallationExtensionsDto[]): InstallationExtensionsModel[] => {
  const transformedData: InstallationExtensionsModel[] = dto.map((id, index) => ({
    state: dto[index].state,
    extension: dto[index].extension === 'lumenaza' ? 'luoxDirectMarketing' : (dto[index].extension as ExtensionType),
  }))

  return transformedData
}

export default fromDtoToModelTransformer
